<template>
  <div :class="[arrowPosition === 'left' ? 'error-tip-left' : 'error-tip-right']">
    <span>
      {{ content }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ErrorTip',
  props: {
    content: {
      type: String,
      default: ''
    },
    arrowPosition: { // 箭头相对位置，靠左为left，靠右为right
      type: String,
      default: 'left'
    }
  }
};
</script>

<style scoped lang="scss">

  %error-tip {
    z-index: 10;
    position: absolute;
    line-height: 20px;
    border: 1px solid red;
    margin-top: 5px;
    background: #fff;
  }

  %error-before {
    content: '';
    position: absolute;
    top: -7px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid red;
  }

  %error-after {
    content: '';
    position: absolute;
    top: -6px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid white;
  }

  .error-tip-left {
    @extend %error-tip;
    min-width: 70px;
    &::before {
      @extend %error-before;
      left: 10px;
    }
    &::after {
      @extend %error-after;
      left: 10px;
    }
  }

  .error-tip-right {
    @extend %error-tip;
    right: 10px;
    min-width: 100px;
    &::before {
      @extend %error-before;
      right: 10px;
    }
    &::after {
      @extend %error-after;
      right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/slb/detail/defaultServerGroup/ErrorTip.vue